$('a[href^="#privacy"]').click(function(e) {
  e.preventDefault();
  window.semaphore.push(["showPreferences", {
    tab: 'consentsTab',
    showOverviewTab: false,
    showSubscriptionsTab: false
  }]);
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event('change', { bubbles: true });
  }

  connectedCallback() {
    this.input = this.querySelector('input');
    if (!this.input) return;
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
    this.input.addEventListener('input', this.onManualInput.bind(this));
    this.input.addEventListener('change', this.onManualInput.bind(this));
    this.tooltipTimeout = null;
  }

  getMin() {
    const parsed = parseInt(this.input.min);
    return isNaN(parsed) ? 0 : parsed;
  }

  getMax() {
    const parsed = parseInt(this.input.max);
    return isNaN(parsed) ? null : parsed;
  }

  onManualInput() {
    if (!this.input) return;
    const value = parseInt(this.input.value);
    const min = this.getMin();
    const max = this.getMax();

    if (max !== null && value > max) {
      this.input.value = max;
      this.announceMax(max);
    } else if (isNaN(value) || value < min) {
      this.input.value = min;
    }
  }

  /* Surfaces that show the limit in context (cart line items) cancel this and
     render their own message instead of the floating tooltip. */
  announceMax(max) {
    const reachedEvent = new CustomEvent('quantity:max', {
      bubbles: true,
      cancelable: true,
      detail: { max },
    });

    if (this.dispatchEvent(reachedEvent)) this.showMaxTooltip(max);
  }

  maxMessage(max) {
    if (this.dataset.maxMessage) return this.dataset.maxMessage;
    if (window.cartStrings && window.cartStrings.quantityError) {
      return window.cartStrings.quantityError.replace('[quantity]', max);
    }
    return null;
  }

  showMaxTooltip(max) {
    const message = this.maxMessage(max);
    if (!message) return;

    if (this.tooltip) {
      clearTimeout(this.tooltipTimeout);
      this.tooltip.remove();
    }

    this.tooltip = document.createElement('div');
    this.tooltip.textContent = message;
    Object.assign(this.tooltip.style, {
      position: 'absolute',
      bottom: 'calc(100% + 8px)',
      left: '50%',
      transform: 'translateX(-50%)',
      background: '#1a1a1a',
      color: '#fff',
      padding: '6px 12px',
      borderRadius: '6px',
      fontSize: '12px',
      fontWeight: '600',
      whiteSpace: 'nowrap',
      zIndex: '100',
      pointerEvents: 'none',
      opacity: '0',
      transition: 'opacity 0.2s ease',
    });

    this.style.position = 'relative';
    this.appendChild(this.tooltip);

    requestAnimationFrame(() => {
      if (this.tooltip) this.tooltip.style.opacity = '1';
    });

    this.tooltipTimeout = setTimeout(() => {
      if (this.tooltip) {
        this.tooltip.style.opacity = '0';
        setTimeout(() => {
          if (this.tooltip) {
            this.tooltip.remove();
            this.tooltip = null;
          }
        }, 200);
      }
    }, 2500);
  }

  onButtonClick(event) {
    event.preventDefault();
    if (!this.input) return;
    const button = event.currentTarget;
    if (!button || !button.name) return;
    const previousValue = this.input.value;
    const min = this.getMin();
    const max = this.getMax();
    const step = parseInt(this.input.step) || 1;
    const current = parseInt(this.input.value) || 0;

    if (button.name === 'plus') {
      const next = current + step;
      if (max !== null && next > max) {
        this.input.value = max;
        this.announceMax(max);
      } else {
        this.input.value = next;
        if (max !== null && next === max) {
          this.announceMax(max);
        }
      }
    } else {
      this.input.value = Math.max(min, current - step);
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', () => this.loadContent(true));
  }

  connectedCallback() {
    if (!this.hasAttribute('data-autoplay') || this.getAttribute('loaded')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.loadContent(false);
  }

  loadContent(pauseOthers = true) {
    if (pauseOthers) window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const template = this.querySelector('template');
      if (!template) return;

      const content = document.createElement('div');
      content.appendChild(template.content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const mediaEl = content.querySelector('video, model-viewer, iframe');
      if (!mediaEl) return;
      this.appendChild(mediaEl);

      if (mediaEl.tagName === 'VIDEO') {
        mediaEl.muted = true;
        mediaEl.defaultMuted = true;
        mediaEl.volume = 0;
        mediaEl.setAttribute('muted', '');
        mediaEl.playsInline = true;

        if (this.hasAttribute('data-autoplay')) {
          mediaEl.removeAttribute('controls');
          mediaEl.addEventListener('volumechange', () => {
            if (!mediaEl.muted || mediaEl.volume > 0) {
              mediaEl.muted = true;
              mediaEl.volume = 0;
            }
          });
        }

        const playPromise = mediaEl.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      }

      if (typeof mediaEl.focus === 'function' && pauseOthers) mediaEl.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    // Skip variant change if triggered by a size-quantity number input
    if (event && event.target && event.target.classList.contains('size-quantity-input')) {
      return;
    }

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    // Determine if we should reset size-qty inputs (only when a non-size option changes)
    const changedFieldset = event && event.target ? event.target.closest('fieldset') : null;
    this._resetSizeQty = !(changedFieldset && changedFieldset.classList.contains('variant-picker__option--size-qty'));

    // Immediately reset size-qty visuals so CSS transition starts right away (before fetch)
    if (this._resetSizeQty) {
      const sizeQtyFieldset = this.querySelector('.variant-picker__option--size-qty');
      if (sizeQtyFieldset) {
        sizeQtyFieldset.querySelectorAll('.variant-picker__item-row').forEach(function(row) {
          var input = row.querySelector('.size-quantity-input');
          if (input) input.value = '0';
          row.classList.remove('variant-picker__item-row--has-quantity');
        });
      }
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;

    const sectionId = this.dataset.section;
    const mediaList = document.getElementById(`ProductMediaList-${sectionId}`);
    const modalContent = document.querySelector(`#ProductModal-${sectionId} .product-media-modal__content`);
    const filterByColor = mediaList && mediaList.dataset.filterByColor === 'true';

    if (filterByColor) {
      const colorOptionIndex = parseInt(this.dataset.colorOptionIndex || mediaList.dataset.colorOptionIndex || '0', 10);
      const selectedColor = this.currentVariant.options[colorOptionIndex];
      let visibleCount = 0;

      mediaList.querySelectorAll('.product__media-item').forEach((item) => {
        const group = item.dataset.colorGroup;
        const hide = !group || group !== selectedColor;
        item.classList.toggle('product__media-item--color-hidden', hide);
        if (!hide) visibleCount += 1;
      });

      if (modalContent) {
        // Only toggle wrappers — product-media also puts data-media-id on nested
        // <img>/deferred-media, which lack data-color-group and would always hide.
        modalContent.querySelectorAll('.product-media-modal__item').forEach((item) => {
          const group = item.dataset.colorGroup;
          const hide = !group || group !== selectedColor;
          item.classList.toggle('product__media-item--color-hidden', hide);
        });
        modalContent
          .querySelectorAll('[data-media-id].product__media-item--color-hidden:not(.product-media-modal__item)')
          .forEach((el) => {
            el.classList.remove('product__media-item--color-hidden');
          });
      }

      mediaList.dataset.selectedColor = selectedColor || '';

      const sliderButtons = mediaList.parentElement && mediaList.parentElement.querySelector('[data-media-slider-buttons]');
      const totalEl = mediaList.parentElement && mediaList.parentElement.querySelector('[data-media-slider-total]');
      if (totalEl) totalEl.textContent = String(visibleCount);
      if (sliderButtons) sliderButtons.classList.toggle('small-hide', visibleCount < 2);
    }

    if (!this.currentVariant.featured_media) return;

    const newMedia = document.querySelector(
      `[data-media-id="${sectionId}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;

    const parent = newMedia.parentElement;
    if (modalContent) {
      const newMediaModal = modalContent.querySelector(
        `.product-media-modal__item[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      if (newMediaModal && modalContent.firstElementChild !== newMediaModal) {
        modalContent.prepend(newMediaModal);
      }
    }

    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    window.setTimeout(() => {
      if (parent) parent.scrollLeft = 0;
      newMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        const sizeQtyFieldset = this.querySelector('.variant-picker__option--size-qty');

        if (sizeQtyFieldset && this._resetSizeQty) {
          this.syncSizeQuantityFieldset(sizeQtyFieldset, html);
        }
        this._resetSizeQty = false;

        this.syncVariantAvailability(html);

        // Re-sync with cart after variant rows are updated
        if (typeof window.syncSizeQuantityWithCart === 'function') {
          window.syncSizeQuantityWithCart().then(() => {
            this.updateAddButtonForSizeQty(sizeQtyFieldset);
          });
        } else {
          this.updateAddButtonForSizeQty(sizeQtyFieldset);
        }
      });
  }

  /**
   * Syncs the size-quantity fieldset with fresh data from the server response.
   * Either patches rows in-place (for smooth CSS transitions) or replaces the
   * entire fieldset when the structure has changed.
   */
  syncSizeQuantityFieldset(currentFieldset, html) {
    const selector = `variant-radios[data-section="${this.dataset.section}"], variant-selects[data-section="${this.dataset.section}"]`;
    const newVariantPicker = html.querySelector(selector);
    if (!newVariantPicker) return;

    const newFieldset = newVariantPicker.querySelector('.variant-picker__option--size-qty');
    if (!newFieldset) return;

    const currentRows = currentFieldset.querySelectorAll('.variant-picker__item-row');
    const newRows = newFieldset.querySelectorAll('.variant-picker__item-row');

    if (currentRows.length !== newRows.length) {
      currentFieldset.innerHTML = newFieldset.innerHTML;
      return;
    }

    currentRows.forEach((row, i) => {
      this.patchSizeQuantityRow(row, newRows[i]);
    });
  }

  /**
   * Updates a single size-quantity row to reflect the new variant data
   * (variant id, inventory, availability, disabled state) and resets its value.
   */
  patchSizeQuantityRow(row, newRow) {
    const input = row.querySelector('.size-quantity-input');
    const newInput = newRow.querySelector('.size-quantity-input');

    if (input && newInput) {
      input.setAttribute('data-variant-id', newInput.getAttribute('data-variant-id') || '');
      input.setAttribute('name', newInput.getAttribute('name') || '');

      this.syncInventoryAttributes(input, newInput);

      input.value = '0';

      this.syncDisabledState(input, newInput);
    }

    const isOutOfStock = newRow.classList.contains('variant-picker__item-row--out-of-stock');
    row.classList.toggle('variant-picker__item-row--out-of-stock', isOutOfStock);
    row.setAttribute('data-available', newRow.getAttribute('data-available') || '');
    row.classList.remove('variant-picker__item-row--has-quantity');
  }

  syncInventoryAttributes(input, newInput) {
    if (newInput.hasAttribute('max')) {
      input.setAttribute('max', newInput.getAttribute('max'));
      input.setAttribute('data-inventory-quantity', newInput.getAttribute('data-inventory-quantity') || '');
    } else {
      input.removeAttribute('max');
      input.removeAttribute('data-inventory-quantity');
    }
  }

  syncDisabledState(input, newInput) {
    if (newInput.hasAttribute('disabled')) {
      input.setAttribute('disabled', '');
    } else {
      input.removeAttribute('disabled');
    }
  }

  /**
   * Toggles the add-to-cart button based on whether any size-quantity rows
   * are available, or falls back to the current variant's availability.
   */
  updateAddButtonForSizeQty(sizeQtyFieldset) {
    if (!sizeQtyFieldset) {
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      return;
    }

    const rows = sizeQtyFieldset.querySelectorAll('.variant-picker__item-row');
    const anyAvailable = Array.from(rows).some(
      (row) => !row.classList.contains('variant-picker__item-row--out-of-stock') && !row.classList.contains('variant-picker__item-row--in-cart')
    );

    if (rows.length > 0 && !anyAvailable) {
      this.toggleAddButton(true, window.variantStrings.soldOut);
    } else {
      this.toggleAddButton(false);
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  syncVariantAvailability(html) {
    const selector = `variant-radios[data-section="${this.dataset.section}"], variant-selects[data-section="${this.dataset.section}"]`;
    const newPicker = html.querySelector(selector);
    if (!newPicker) return;

    const currentFieldsets = this.querySelectorAll('fieldset.product-form__input:not(.variant-picker__option--size-qty)');
    const newFieldsets = newPicker.querySelectorAll('fieldset.product-form__input:not(.variant-picker__option--size-qty)');

    currentFieldsets.forEach((fieldset, fi) => {
      const newFieldset = newFieldsets[fi];
      if (!newFieldset) return;

      const currentRadios = fieldset.querySelectorAll('input[type="radio"][data-variant-available]');
      const newRadios = newFieldset.querySelectorAll('input[type="radio"][data-variant-available]');

      currentRadios.forEach((radio, ri) => {
        const newRadio = newRadios[ri];
        if (!newRadio) return;

        const isAvailable = newRadio.getAttribute('data-variant-available') === 'true';
        const label = radio.nextElementSibling;

        if (isAvailable) {
          radio.removeAttribute('disabled');
          radio.setAttribute('data-variant-available', 'true');
          if (label) label.classList.remove('variant-picker__item--sold-out');
        } else {
          radio.setAttribute('disabled', '');
          radio.setAttribute('data-variant-available', 'false');
          if (label) label.classList.add('variant-picker__item--sold-out');
        }
      });
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
